import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { ActionBar, BtnRow, Content, DashList, DataListWrap, EditContent, Img, PickButton, PopupContent, PopupWrapper, Td, TitleLeft, TopBar } from './ApprovalDetails.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import StudentThumbnail from '@components/StudentThumbnail';

import Cross_Icon from "@assets/svg/match/missing.svg";
import Note_Icon from "@assets/svg/notes.svg";
import Profile_Icon from "@assets/svg/profile.svg";
import Edit_Icon from "@assets/svg/pencil.svg";
import Pagination from '../Pagination';
import SortArrow from '../SortArrow';
import Modal from '@components/Buttons/Modal';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import EmptyBox from '../EmptyBox';
import S_Icon from "@assets/svg/s_icon.svg";
import { FilterBox, FilterButton, FilterButtons, FilterDrop, FilterInput, FilterItem, FilterReset, FilterText } from '../SchoolLeader.styled';
import { GenerateExcelFile } from '../excel';


interface IProps { getApprovals: () => void, loading: boolean, handleClick: (username, id, displayname, type, sick?) => void }

export const ApprovalDetails = forwardRef((props: IProps, ref) => {
  useImperativeHandle(ref, () => ({
    exportExcel() {
      Excel()
    },
  }));
  const { client, handleNote, schoolViewApprovals, setSchoolViewApprovals, page, setPage, schoolViewFilter } = useStore();
  const i18n = useI18n();
  const [open, setOpen] = useState(false);
  const openRef = useRef(null)
  const [sort, setSort] = useState({ type: 0, direction: false })
  const [editItem, setEditItem] = useState(null)
  const [text, setText] = useState('')
  const [id, setId] = useState(null)
  const pageSize = 13;

  useEffect(() => {
    getApprovals()
  }, [])

  const getApprovals = async () => {
    await props.getApprovals()
  }

  function handleSort(type) {
    let direction = false;
    if (type === sort.type) direction = !sort.direction
    setSort({ type: type, direction: direction })
  }

  const getFilteredApprovals = () => {
    let approvalsTenmp = JSON.parse(JSON.stringify(schoolViewApprovals))
    approvalsTenmp = approvalsTenmp?.filter(s => s.displayname?.toLowerCase().includes(schoolViewFilter.search5?.toLowerCase()))
    return approvalsTenmp
  }

  function getSortedApprovals() {
    let approvalTemp = getFilteredApprovals()
    approvalTemp = approvalTemp?.sort((a, b) => {
      let dir = sort.direction ? -1 : 1
      switch (sort.type) {
        case 0:
          if (a.displayname > b.displayname) return 1 * dir
          else if (a.displayname < b.displayname) return -1 * dir
          else return 0
          break;
        case 1:
          if (a.createdatetimestamp > b.createdatetimestamp) return 1 * dir
          else if (a.createdatetimestamp < b.createdatetimestamp) return -1 * dir
          else return 0
          break;
        case 2:
          let startA = moment(a.startdatetime)
          let endA = moment(a.enddatetime)
          let startB = moment(b.startdatetime)
          let endB = moment(b.enddatetime)
          if (startA.isAfter(startB)) return 1 * dir
          else if (startA.isBefore(startB)) return -1 * dir
          else if (endA.isAfter(endB)) return 1 * dir
          else if (endA.isBefore(endB)) return -1 * dir          
          else return 0
          break;
        case 3:
          if (a.request_text > b.request_text) return 1 * dir
          else if (a.request_text < b.request_text) return -1 * dir
          else return 0
          break;
        case 4:
          if (a.approve_text > b.approve_text) return 1 * dir
          else if (a.approve_text < b.approve_text) return -1 * dir
          else return 0
          break;
      }
    })
    return approvalTemp
  }

  const getPeriod = (startDate, endDate) => {
    let start = moment(startDate)
    let end = moment(endDate)
    return (start.format('DD-MM-YYYY') + ' - ' + end.format('DD-MM-YYYY'))
  }

  const handleClose = () => {
    setEditItem(null)
    setText('')
    setId(null)
    openRef.current.handleClose()
  }

  const handleEdit = (item) => {
    setEditItem(item)
    setText(item.approve_text)
    setId(item.request_id)
    setOpen(true)
  }

  const handleOpen = (id, item) => {
    setEditItem(item)
    setId(id)
    setOpen(true)
  }

  const handleRequest = async (approve: boolean) => {
    if (id) {
      if (!approve) {
        if (text !== "") {
          let request = await db.ApproveDenyRequest(id, client.UserName, approve, text)
        }
      }
      else {
        let request = await db.ApproveDenyRequest(id, client.UserName, approve, text)
      }
      handleClose()
      getApprovals()
    }
  }

  const getTextCount = () => {
    let count = getFilteredApprovals()?.length
    let totalCount = schoolViewApprovals?.length
    if (totalCount === count && count > 0) {
      return `${i18n.t('showing')} ${i18n.t('all').toLowerCase()} ${totalCount}`
    }
    else {
      if (count > 0) {
        return `${i18n.t('showing')} ${count} ${i18n.t('of')} ${totalCount}`
      }
      else
        return ""
    }
  }

  const Excel = () => {
    let data = getSortedApprovals().map(r => {
      let object = {}

      object[i18n.t("header-name")] = r.displayname;
      object[i18n.t("period")] = getPeriod(r.startdatetime, r.enddatetime);
      object[i18n.t("header-created")] = moment(r.createdatetimestamp).format('DD-MM-YYYY')
      object[i18n.t("header-comment")] = r.request_text;
      object[i18n.t("header-answer")] = r.approve_text;
      object[i18n.t("header-action")] = r.waiting ? i18n.t("waiting") : (r.approved ? i18n.t("approved") : i18n.t("rejected"));
      return object;
    });

    let headers = [
      i18n.t("header-name"),
      i18n.t("period"),
      i18n.t("header-created"),
      i18n.t("header-comment"),
      i18n.t("header-answer"),
      i18n.t("header-action"),
    ];

    GenerateExcelFile(i18n.t("sub-nav5").replace('/','_') + "_" + moment().format('DD-MM-YYYY-HHmm'), headers, data, i18n.t("sub-nav5").replace('/','_') + "_" + moment().format('DD-MM-YYYY-HHmm'));
  }

  return (<>
    {open ? <Modal ref={openRef} onClose={setOpen} backColor='rgba(0,0,0,0.25)'>
      <PopupWrapper>
        <TopBar>
          <span>{i18n.t("approval-title")}</span>
          <button onClick={() => handleClose()}><Cross_Icon /></button>
        </TopBar>

        <PopupContent>
          <span>{i18n.t("header-name")}: <b>{editItem ? editItem.displayname : null}</b></span>
          <span>{i18n.t("period")}: <b>{editItem ? getPeriod(editItem.startdatetime, editItem.enddatetime) : null}</b></span>
          <span>{i18n.t("header-comment")}: <b>{editItem ? editItem.request_text : null}</b></span>
          <p>{i18n.t("approval-text1")}</p>
          <textarea value={text} onChange={e => setText(e.target.value)} placeholder={i18n.t("approval-text2")} />
        </PopupContent>
        <BtnRow>
          <button onClick={() => handleRequest(true)}>{i18n.t("approve")}</button>
          <button disabled={text === ""} onClick={() => handleRequest(false)}>{i18n.t("reject")}</button>
          <button onClick={() => handleClose()}>{i18n.t("close")}</button>
        </BtnRow>
      </PopupWrapper>
    </Modal> : null}

    <Content>
      <TitleLeft>
        <span>{i18n.t("sub-nav5")}</span>
        <span>{getTextCount()}</span>
      </TitleLeft>

      {props.loading ? <RainbowLoader /> : getSortedApprovals()?.length > 0 ? <><DataListWrap>
        <DashList>
          <tbody>
            <tr>
              <td className={"imgWidth"}></td>
              <Td onClick={() => handleSort(0)}>{i18n.t("header-name")} <SortArrow sortActive={sort.type === 0} asc={sort.type === 0 && sort.direction === false} /></Td>
              <Td onClick={() => handleSort(2)}>{i18n.t("period")} <SortArrow sortActive={sort.type === 2} asc={sort.type === 2 && sort.direction === false} /></Td>
              <Td onClick={() => handleSort(1)}>{i18n.t("header-created")} <SortArrow sortActive={sort.type === 1} asc={sort.type === 1 && sort.direction === false} /></Td>
              <Td>{i18n.t("header-comment")}</Td>
              <Td>{i18n.t("header-answer")}</Td>
              <Td onClick={() => handleSort(5)}>{i18n.t("header-action")} <SortArrow sortActive={sort.type === 5} asc={sort.type === 5 && sort.direction === false} /></Td>
              <td></td>
            </tr>
            {schoolViewApprovals ? getSortedApprovals().slice((page * pageSize - pageSize), pageSize * page).map((a, index) => <tr key={"approval_" + index}>
              <td className={"imgWidth"}><Img><StudentThumbnail font={"0.9em"} name={a?.displayname} src={a.username} /></Img></td>
              <td className={"clickable"} onClick={() => props.handleClick(a.username, a.student_id, a.displayname, "STUDENT")}>{a.displayname}</td>
              <td>{getPeriod(a.startdatetime, a.enddatetime)}</td>
              <td><span>{moment(a.createdatetimestamp).format('DD-MM-YYYY')}</span></td>
              <td>{a.request_text}</td>
              <td>{a.approve_text}</td>
              <td>
                {a.waiting ?
                  <PickButton onClick={() => handleOpen(a.request_id, a)}>{i18n.t("pick-action")}</PickButton>
                  :
                  <EditContent aproved={a.approved} onClick={() => handleEdit(a)} >{a.approved ? i18n.t("approved") : i18n.t("rejected")}<Edit_Icon /></EditContent>
                }
              </td>
              <td>
                <ActionBar>
                  <Note_Icon onClick={() => handleNote(a.student_id, a.displayname)} />
                </ActionBar>
              </td>
            </tr>) : null}
          </tbody>
        </DashList>
      </DataListWrap>

        <Pagination count={getSortedApprovals()?.length} pageSize={pageSize} currentPage={page} maxPage={Math.ceil(getSortedApprovals()?.length / pageSize)} setPage={setPage} /></> : <EmptyBox Graphic='documents' marvin={true} text={i18n.t("no-filter-data")} />}

    </Content>
  </>);
});

export default ApprovalDetails;
